import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  ${({ theme }) => theme.fontFace}

  html {
    box-sizing: border-box;
    font-variant-ligatures: no-contextual;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }

  body {
    margin: 0;
    color: ${({ theme }) => theme?.textColor || 'black'};
    font-family: ${({ theme }) => theme?.fontBase || 'sans-serif'};
    font-size: ${({ theme }) => theme?.textSize || '16px'};
    line-height: ${({ theme }) => theme?.lineHeight || 'normal'};
  }

  #root {
    display: flex;
    min-height: 100vh;
    align-items: flex-start;
    position: relative;
  }

  p {
    margin: 0;
  }
`;
